import React, { useState, useCallback } from "react";
import { useJsApiLoader, GoogleMap, Marker } from "@react-google-maps/api";

const googleLibs = ["geometry", "drawing", "places"];
const containerStyle = {
  width: "100%",
  height: "400px",
};

const Map = (props) => {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyCOvhLp91bec2hT3CZgBguhqcFoiHFoig8",
    version: "3.exp",
    libraries: googleLibs,
  });
  const [map, setMap] = useState(null);
  const center = { lat: 0, lng: 0 };

  const onLoad = useCallback(function callback(map) {
    /*const bounds = new window.google.maps.LatLngBounds(center);
    map.fitBounds(bounds);*/
    setMap(map);
  });
  const onUnmount = useCallback(function callback(map) {
    setMap(null);
  });
  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={containerStyle}
      zoom={2}
      center={center}
      onLoad={onLoad}
      onUnmount={onUnmount}
    >
      {props.coordenates.map((m, i) => (
        <Marker
          key={i}
          position={{ lat: m.lat, lng: m.lng }}
          title={m.country}
        ></Marker>
      ))}
    </GoogleMap>
  ) : (
    <></>
  );
};

export default Map;
